import { useState, useEffect } from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import { BunnyCharacter } from '../components/BunnyCharacter'
import { PinInput } from '../components/ui/PinInput'
import { useAuth } from '../hooks/useAuth'

export function LoginPage() {
  const { register, login, error, loading } = useAuth()
  const [isFirstTime, setIsFirstTime] = useState<boolean | null>(null)

  useEffect(() => {
    fetch('/api/auth/status')
      .then((res) => res.json())
      .then((data: { registered: boolean }) => setIsFirstTime(!data.registered))
      .catch(() => setIsFirstTime(false))
  }, [])

  const handlePinComplete = async (pin: string) => {
    if (isFirstTime) {
      await register(pin)
    } else {
      await login(pin)
    }
  }

  return (
    <div className="flex flex-col items-center justify-center min-h-dvh p-6 bg-cream">
      <motion.div
        initial={{ y: -50, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ type: 'spring', stiffness: 200, damping: 20 }}
        className="mb-4"
      >
        <BunnyCharacter size="lg" animate="idle" />
      </motion.div>

      <motion.h1
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.3 }}
        className="font-heading text-3xl text-ink mb-2 text-center"
      >
        Påskharens
      </motion.h1>
      <motion.h2
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.5 }}
        className="font-heading text-2xl text-turquoise mb-8 text-center"
      >
        Äggäventyr
      </motion.h2>

      {isFirstTime === null ? (
        <p className="text-turquoise font-body">Laddar...</p>
      ) : (
        <motion.div
          key="pin"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="w-full max-w-sm"
        >
          <p className="font-body text-lg text-ink/70 text-center mb-6">
            {isFirstTime ? 'Välj en familje-PIN (4 siffror)' : 'Ange familje-PIN'}
          </p>
          <PinInput onComplete={handlePinComplete} error={error || undefined} />
          {loading && (
            <p className="text-center mt-4 text-turquoise font-body">
              Vänta lite...
            </p>
          )}
        </motion.div>
      )}
    </div>
  )
}
